/* eslint-disable react/display-name */
import { SCREENS_ROUTES_ENUMS } from 'common/enum';
import Login from 'pages/public-route/Login';
import ResendVerificationEmail from 'pages/public-route/ResendVerificationEmail';
import ResetPassword from 'pages/public-route/ResetPassword';
import SignUp from 'pages/public-route/SignUp';
import VerifyEmail from 'pages/public-route/VerifyEmail';
import TraineeDashboard from 'pages/public-route/TraineeDashboard';
import UserForgotPasswordComp from 'pages/user-public-route/ForgetPassword';
import UserLogin from 'pages/user-public-route/UserLogin';
import { Navigate } from 'react-router-dom';
import { IRoutes } from '../route-lists';

export const userPublicRoutes: IRoutes[] = [
  {
    path: SCREENS_ROUTES_ENUMS.USER_SIGN,
    title: 'Sign',
    element: <UserLogin />,
    isPublic: true,
    children: [{ path: '*', element: <Navigate to="/404" /> }]
  },
  {
    path: SCREENS_ROUTES_ENUMS.SIGN_IN,
    title: 'Sign',
    element: <Login />,
    isPublic: true,
    children: [{ path: '*', element: <Navigate to="/404" /> }]
  },
  {
    path: SCREENS_ROUTES_ENUMS.REGISTER,
    title: 'Register',
    element: <SignUp />,
    isPublic: true,
    children: [{ path: '*', element: <Navigate to="/404" /> }]
  },
  {
    path: SCREENS_ROUTES_ENUMS.FORGOT_PASSWORD,
    title: 'ForgotPassword',
    element: <ResendVerificationEmail />,
    isPublic: true,
    children: [{ path: '*', element: <Navigate to="/404" /> }]
  },
  {
    path: SCREENS_ROUTES_ENUMS.VERIFY_OTP,
    title: 'Verify OTP',
    element: <VerifyEmail />,
    isPublic: true,
    children: [{ path: '*', element: <Navigate to="/404" /> }]
  },
  {
    path: SCREENS_ROUTES_ENUMS.RESEND_VERIFY_OTP,
    title: 'Resend Verify OTP',
    element: <ResendVerificationEmail />,
    isPublic: true,
    children: [{ path: '*', element: <Navigate to="/404" /> }]
  },
  {
    path: SCREENS_ROUTES_ENUMS.RESET_PASSWORD,
    title: 'Reset Password',
    element: <ResetPassword />,
    isPublic: true,
    children: [{ path: '*', element: <Navigate to="/404" /> }]
  },
  {
    path: 'user-reset-password/:uid/:paramToken/',
    title: 'Reset Password',
    element: <UserForgotPasswordComp />,
    isPublic: true,
    children: [{ path: '*', element: <Navigate to="/404" /> }]
  },
  {
    path: SCREENS_ROUTES_ENUMS.TRAINEE_PUBLIC_DASHBOARD,
    title: 'Trainee Public Dashboard',
    element: <TraineeDashboard />,
    isPublic: true
  }
];
